import { faPhotoFilm } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import React from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

export default function ButtonDivToPDF({ nome, textButton, email }) {
  const downloadDivAsPdf = () => {
    const targetId = 'node_to_pdf2025';
    const targetNode = document.getElementById(targetId);

    if (!targetNode) {
      alert('Elemento da carteirinha não encontrado!');
      return;
    }

    html2canvas(targetNode, {
      scale: 2, // Aumente esse valor se necessário
      useCORS: true, // Importante para iPhone e imagens externas
      allowTaint: false,
      backgroundColor: null
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');

      // Calcular a largura e a altura do PDF
      const pdfWidth = canvas.width;
      const pdfHeight = canvas.height;

      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: [pdfWidth, pdfHeight], // Use as dimensões do canvas
      });

      // Ajuste as dimensões da imagem para preencher o PDF
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

      // Adiciona o link clicável
      const scale = 2;
      const linkX = 122 * scale;
      const linkY = pdfHeight - 195;
      const linkWidth = 107 * scale;
      const linkHeight = 35 * scale;

      pdf.link(linkX, linkY, linkWidth, linkHeight, {
        url: `https://funemg.vercel.app/certificado/${email}`,
      });

      pdf.save(`${nome}.pdf`);
    }).catch((err) => {
      console.error('Erro ao gerar imagem com html2canvas:', err);
      alert('Erro ao gerar a carteirinha.');
    });
  };


  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '30px 0' }}>
      <Button
        onClick={downloadDivAsPdf}
        startIcon={<FontAwesomeIcon icon={faPhotoFilm} />}
        style={{ background: '#70C4A5' }}
        variant="contained"
      >
        {textButton}
      </Button>
    </div>
  );
}
